<template>
  <v-text-field
    id="list-search"
    v-model="searchQuery"
    label="Search"
    height="40"
    hide-details
    solo
    flat
    background-color="na-dark-cream"
    single-line
    color="#535353"
    class="ml-auto search"
    @input="searchList"
  >
    <v-icon
      slot="prepend-inner"
      color="#535353"
    >
      $faSearch
    </v-icon>
  </v-text-field>
</template>

<script>
  export default {
    name: 'SearchLists',
    data: () => ({
      searchQuery: '',
    }),
    methods: {
      searchList (query) {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('search', this.searchQuery)
        }, 500)
      },
    },
  }
</script>
<style lang="scss">
#list-search {
  width: 231px;
  background-color:$na-dark-cream;
}
</style>
